import React from 'react';

import { FloatingAudioContainer } from '@confluence/audio/entry-points/FloatingAudioContainer.ts';
import { ConditionalCreateSpaceDrawer } from '@confluence/create-space/entry-points/createSpace.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { ForgeGlobalKeyboardShortcuts } from '@confluence/forge-ui/entry-points/ForgeGlobalKeyboardShortcuts.ts';
import {
	ConditionalImportContentDrawer,
	ConditionalImportContentModal,
} from '@confluence/import-content/entry-points/importContent.ts';
import { ConditionalSingleImportModal } from '@confluence/single-import-modal/entry-points/SingleImportModal.ts';
import { LazyRestrictionsDialogMountPoint } from '@confluence/restrictions/entry-points/RestrictionsDialogTrigger.ts';
import { StorageEnforcement } from '@confluence/storage-enforcement/entry-points/StorageEnforcement.ts';

import { GrowthComponentsLoader } from './GrowthComponentsLoader.tsx';
import { OnboardingComponentsLoader } from './OnboardingComponentsLoader.tsx';
import { SmartCreationComponentLoader } from './SmartCreationComponentLoader.tsx';
import { TrialAndUpgradeComponentsLoader } from './TrialAndUpgradeComponentsLoader.tsx';

/**
 * Use this component to render global components that should be rendered on every page.
 */
export const GlobalComponents = () => {
	return (
		<>
			<ErrorBoundary
				attribution={Attribution.DISCO}
				attributes={{
					errorBoundaryId: 'GlobalComponents-Disco',
				}}
			>
				<ConditionalCreateSpaceDrawer />
			</ErrorBoundary>

			<SmartCreationComponentLoader />

			<ErrorBoundary
				attribution={Attribution.CC_IMPORTER}
				attributes={{
					errorBoundaryId: 'GlobalComponents-Importer',
				}}
			>
				<ConditionalImportContentModal />
				<ConditionalImportContentDrawer />
				<ConditionalSingleImportModal />
			</ErrorBoundary>

			<ErrorBoundary
				attribution={Attribution.ECOSYSTEM}
				attributes={{
					errorBoundaryId: 'GlobalComponents-Ecosystem',
				}}
			>
				<ForgeGlobalKeyboardShortcuts />
			</ErrorBoundary>

			<ErrorBoundary
				attribution={Attribution.ADMIN_EXPERIENCE}
				attributes={{
					errorBoundaryId: 'GlobalComponents-AdminExperience',
				}}
			>
				<StorageEnforcement />
			</ErrorBoundary>

			<TrialAndUpgradeComponentsLoader />

			<ErrorBoundary attribution={Attribution.PERMISSIONS_EXPERIENCE}>
				<LazyRestrictionsDialogMountPoint />
			</ErrorBoundary>

			<OnboardingComponentsLoader />

			<GrowthComponentsLoader />

			<ErrorBoundary
				attribution={Attribution.SMARTS}
				attributes={{
					errorBoundaryId: 'GlobalComponents-Audio',
				}}
			>
				<FloatingAudioContainer />
			</ErrorBoundary>
		</>
	);
};
